/**
 * Downloads a file from a (pre-signed) URL and returns it as a Blob. Shared by the
 * public signing document hooks so the fetch-then-blob step — and its error — live
 * in one place rather than being copied per hook.
 */
export const downloadFileBlob = async (downloadUrl: string): Promise<Blob> => {
	const fileResponse = await fetch(downloadUrl);
	if (!fileResponse.ok) {
		throw new Error('Failed to download document file');
	}
	return fileResponse.blob();
};
